import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    title: 'leading-none p-0 m-0 font-medium text-sm text-fg-base',
  },
}));
